import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-457f66e6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-sousuo1"
}, null, -1));
const _hoisted_3 = {
  class: "notes"
};
const _hoisted_4 = {
  key: 1
};
import { ref, reactive } from "vue";
import Dialog from "./components/dialog.vue";
import AssignTask from "./components/assignTask.vue";
import api from "@/api/task";
import userApi from "@/api/system/users";
import { useStore } from "@/store/index";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";
export default {
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const {
      t
    } = useI18n();
    const rules = {
      // 手机号只能输入数字或者不输入
      mobile: [{
        validator: (rule, value, callback) => {
          console.log(value);
          if (value === "") {
            callback();
          } else if (/^\d+$/.test(value)) {
            callback();
          } else {
            callback(new Error(t("task.list.mobileError")));
          }
        },
        trigger: "change"
      }]
    };
    const formRef = ref(null);
    const params = reactive({
      page: 1,
      limit: 10,
      uid: "",
      status: undefined,
      platform: 0,
      rechargeStatus: 0,
      mobile: ""
    });
    const list = ref([]);
    const loading = ref(false);
    const total = ref(0);
    const statusDiaRef = ref(null);
    const selectedList = ref([]);
    const assignTask = ref(null);
    const userList = ref([]);
    const statusOpitons = ref([{
      label: t("task.list.status_map.1"),
      value: 1
    }, {
      label: t("task.list.status_map.2"),
      value: 2
    }, {
      label: t("task.list.status_map.3"),
      value: 3
    }, {
      label: t("task.list.status_map.4"),
      value: 4
    }, {
      label: t("task.list.status_map.5"),
      value: 5
    }]);
    // const platformOpitons = ref([
    //   {
    //     label: t("task.list.platform_map.0"),
    //     value: 0,
    //   },
    //   {
    //     label: t("task.list.platform_map.1"),
    //     value: 1,
    //   },
    //   {
    //     label: t("task.list.platform_map.2"),
    //     value: 2,
    //   },
    // ]);

    const rechargeStatusOpitons = ref([{
      label: t("task.list.rechargeStatus_map.0"),
      value: 0
    }, {
      label: t("task.list.rechargeStatus_map.1"),
      value: 1
    }, {
      label: t("task.list.rechargeStatus_map.2"),
      value: 2
    }]);
    const loadList = async query => {
      if (query === "query") {
        params.page = 1;
      }
      loading.value = true;
      try {
        const {
          data
        } = await api.list(params);
        if (data.code !== 0) return;
        list.value = data.data.list;
        total.value = data.data.total;
      } finally {
        loading.value = false;
      }
    };
    onMounted(() => {
      loadList("query");
      getUserList();
    });
    const handleSearch = () => {
      formRef.value.validate(valid => {
        if (valid) {
          loadList("query");
        }
      });
    };
    const getUserList = async () => {
      const {
        data: {
          data
        }
      } = await userApi.selectUser();
      userList.value = data && data.list || [];
    };
    const handleClick = val => {
      statusDiaRef.value.open(val);
    };
    const handleSelectionChange = val => {
      selectedList.value = val.map(item => item.id);
    };
    const handleAssign = () => {
      // 拿到选中的列表数据
      if (!selectedList.value.length) {
        return ElMessage.success(t("task.list.tips"));
      }
      assignTask.value.open(selectedList.value);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Pagination = _resolveComponent("Pagination");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_card, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          size: "large",
          inline: true,
          rules: rules,
          model: params,
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('task.list.mobile'),
            prop: "mobile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: _ctx.$t('common.pleaseEnter', {
                val: _ctx.$t('task.list.mobile')
              }),
              modelValue: params.mobile,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.mobile = $event),
              clearable: ""
            }, null, 8, ["placeholder", "modelValue"])]),
            _: 1
          }, 8, ["label"]), _unref(store).info.isManager === 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: _ctx.$t('task.list.user')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: params.uid,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.uid = $event),
              clearable: "",
              style: {
                "width": "200px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  value: item.id,
                  label: item.name
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: _ctx.$t('task.list.status')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: params.status,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => params.status = $event),
              clearable: "",
              style: {
                "width": "200px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusOpitons.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  value: item.value,
                  label: item.label
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('task.list.rechargeStatus')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: params.rechargeStatus,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => params.rechargeStatus = $event),
              clearable: "",
              style: {
                "width": "200px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rechargeStatusOpitons.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  value: item.value,
                  label: item.label
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "success",
              onClick: handleSearch
            }, {
              default: _withCtx(() => [_hoisted_2, _createTextVNode(" " + _toDisplayString(_ctx.$t("common.search")), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]), _unref(store).info.isManager === 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "success",
          onClick: handleAssign
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("task.list.assignTasks")), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          style: {
            "margin-bottom": "20px"
          },
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.id'),
            prop: "id"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.userName'),
            prop: "username",
            width: "150px"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.mobile'),
            prop: "mobile",
            width: "150px"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.status'),
            width: "180px"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("p", null, _toDisplayString(_ctx.$t("task.list.status_map." + row.status)), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.notes'),
            prop: "notes",
            width: "200px"
          }, {
            default: _withCtx(({
              row
            }) => [row.notes ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              class: "item",
              effect: "dark",
              content: row.notes,
              placement: "top-start"
            }, {
              default: _withCtx(() => [_createElementVNode("p", _hoisted_3, _toDisplayString(row.notes || "-"), 1)]),
              _: 2
            }, 1032, ["content"])) : (_openBlock(), _createElementBlock("p", _hoisted_4, "-"))]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.code'),
            prop: "code",
            width: "150px"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.giftAmount'),
            prop: "num",
            width: "150px"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("p", null, _toDisplayString(row.num / 100), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.claimedAt'),
            prop: "claimedAt",
            width: "200px"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.handleAt'),
            prop: "handleAt",
            width: "200px"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.loginAt'),
            prop: "loginAt",
            width: "200px"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.rechargeAt'),
            prop: "rechargeAt",
            width: "200px"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.assignedAt'),
            prop: "assignedAt",
            width: "200px"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('common.action'),
            fixed: "right",
            width: "150px"
          }, {
            default: _withCtx(({
              row
            }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleClick(row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("task.list.editStatus")), 1)]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, '/task/status']])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _withDirectives(_createVNode(_component_Pagination, {
          total: total.value,
          page: params.page,
          "onUpdate:page": _cache[4] || (_cache[4] = $event => params.page = $event),
          limit: params.limit,
          "onUpdate:limit": _cache[5] || (_cache[5] = $event => params.limit = $event),
          onPagination: loadList
        }, null, 8, ["total", "page", "limit"]), [[_vShow, total.value > 0]]), _createVNode(Dialog, {
          ref_key: "statusDiaRef",
          ref: statusDiaRef,
          onLoadList: loadList
        }, null, 512), _createVNode(AssignTask, {
          ref_key: "assignTask",
          ref: assignTask,
          userList: userList.value,
          onLoadList: loadList
        }, null, 8, ["userList"])]),
        _: 1
      });
    };
  }
};